import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/temp/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 录入司机信息
export function saveDriverInfo(data) {
  return request.send({
    url: `/pmy/sys/driver/temp`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑司机信息
export function editDriverInfo(data) {
  return request.send({
    url: `/pmy/sys/driver/temp`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function detailInfo(driverId) {
  return request.send({
    url: `/pmy/sys/driver/temp?driverId=${driverId}`,
    method: "get",
  });
}

export function deleteDriver(driverId) {
  return request.send({
    url: `/pmy/sys/driver/temp?driverId=${driverId}`,
    method: "delete",
  });
}
